import priceContract from "../utils/priceContract";
import Web3 from "web3";

//read functions//
export const estimatedEth = async (dbnConverted) => {
  let response = await priceContract.methods.pboxToEth(dbnConverted).call();
  const etherValue = Web3.utils.fromWei(response, "ether");
  return etherValue;
};
